
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"9","viewBox":"0 0 15 9","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.80852 0.941959L7.15906 6.59959L12.5096 0.941958C12.7672 0.669575 13.1751 0.669575 13.4327 0.941958C13.6849 1.21434 13.6849 1.65129 13.4327 1.918L7.62059 8.06365C7.36835 8.33603 6.95512 8.33603 6.69753 8.06365L0.890824 1.918C0.638593 1.64562 0.638593 1.20867 0.890824 0.941959C1.14306 0.669576 1.55629 0.669576 1.80852 0.941959Z"}}),_c('path',{attrs:{"d":"M7.15994 8.99847C7.51951 8.99847 7.85761 8.85093 8.1152 8.57855L13.9273 2.4329C14.4532 1.87678 14.4532 0.968838 13.9273 0.412722C13.4013 -0.143394 12.5427 -0.143394 12.0167 0.412722L7.15994 5.54828L2.30314 0.412723C2.05091 0.14034 1.70744 -0.00720105 1.34788 -0.00720101C0.988314 -0.00720098 0.650216 0.14034 0.392618 0.412723C-0.133312 0.968839 -0.133312 1.87678 0.392618 2.4329L6.20468 8.57855C6.46228 8.85093 6.80038 8.99847 7.15994 8.99847Z"}})])
          )
        }
      }
    